// extracted by mini-css-extract-plugin
export default {"search_bar":"paientSearch_search_bar__tFuc0","search_bar_height":"paientSearch_search_bar_height__smEyv"};